exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  display: flex;\n  flex-direction: column;\n}\n#root {\n  height: 100%;\n}\n.phone-tablet-show {\n  display: none;\n}\n.phone-show {\n  display: none;\n}\n.phone-hide {\n  display: block;\n}\n@media all and (max-width: 865px) {\n  .phone-tablet-show {\n    display: block;\n  }\n  .phone-tablet-hide {\n    display: none;\n  }\n}\n@media (max-width: 767px) {\n  .phone-hide {\n    display: none;\n  }\n  .phone-show {\n    display: block;\n  }\n}\n@media (min-width: 768px) and (max-width: 1024px) {\n  .tablet-hide {\n    display: none;\n  }\n  .tablet-show {\n    display: block;\n  }\n}\n", ""]);

// exports
